import React from 'react';
import PropTypes from 'prop-types';

/**
 * 테마 필터 및 일괄 삭제 컴포넌트
 * @param {Object} props - 컴포넌트 속성
 * @param {number} props.selectedCount - 선택된 항목 수
 * @param {Function} props.onBulkDelete - 일괄 삭제 핸들러
 * @param {Function} props.onFilterChange - 필터 변경 핸들러
 * @param {string} props.currentFilter - 현재 선택된 필터
 */
const ThemeFilters = ({ 
  selectedCount, 
  onBulkDelete, 
  onFilterChange,
  currentFilter = 'latest'
}) => {
  return (
    <div className="filter-dropdown-container-row">
      {/* 일괄 삭제 버튼 */}
      <div className={`bulk-delete-container ${selectedCount >= 2 ? 'active' : ''}`}>
        <button className="bulk-delete-btn" onClick={onBulkDelete}>
          일괄 삭제 ({selectedCount})
        </button>
      </div>

      <div className="filter-dropdown">
        <select 
          id="theme-filter" 
          value={currentFilter}
          onChange={(e) => onFilterChange(e.target.value)}
        >
          <option value="latest">최신순</option>
          <option value="name">이름순</option>
          <option value="period">사용기간순</option>
        </select>
      </div>
    </div>
  );
};

ThemeFilters.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  onBulkDelete: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func,
  currentFilter: PropTypes.string
};

export default ThemeFilters;